import { initTabAttributeContent } from '@/core/item_assistance/initItemData'
import { setDisabledState } from '@/core/shared'

export function setTabsVisible (visible) {
	var tabElements = $('.tab-content').children()
	var tabAreas = $('.tab-content').find('.attributes-group-area')
	var button
	if (visible) {
		$('#tab-header').css('display', 'none')
		tabElements.each(function (tabIndex, tab) {
			$(tab).attr('class', 'tab-pane fade in active')
		})
		tabAreas.each(function (areaIndex, area) {
			$(area).css('display', 'block')
		})
	} else {
		$('#tab-header').css('display', 'block')
		tabElements.each(function (tabIndex, tab) {
			if (tabIndex == document.activeTabIndex) {
				$(tab).attr('class', 'tab-pane fade in active')
			} else {
				$(tab).attr('class', 'tab-pane fade')
			}
		})
		var tabAreas = $('.tab-content').find('.attributes-group-area')
		tabAreas.each(function (areaIndex, area) {
			$(area).css('display', 'none')
		})
	}
	initTabAttributeContent()
}

export function setDisabledStateOfLockableAttributeControlsWithDefaultValues (disabled) {
	setDisabledState('div .row .def-lock', disabled)
}

export function goToTabPaneByElement (element) {
	var tabPaneId = element.closest('.tab-pane').attr('id')
	if (tabPaneId) {
		$('a[href=\'#' + tabPaneId + '\']').click()
	}
}

export function setFocusOnAttribute (activeAttr) {
	let elements = $('div[id=' + activeAttr + '__area]')
	_.each(elements, function (el) {
		let wrapper = $(el).find('.col-sm-7')
		if (wrapper.find('textarea').length) {
			wrapper.find('textarea').addClass('blink')
			setTimeout(() => wrapper.find('textarea').removeClass('blink'), 10000)
		} else {
			wrapper.addClass('blink')
			setTimeout(() => wrapper.removeClass('blink'), 10000)
		}
	})
	elements.find('input, textarea').eq(0).focus()
}

export function setFocusOnField (field) {
	$('#' + field).focus()
}

export function attachRegistrationOfSelectedAttribute (tradeItem) {
	$('.page').on('focus', '.attribute-editor:not(.bg-editor)', function (e) {
		tradeItem.selectedAttribute = $(e.target).attr('id')
	})
}

export function isGroupMode () {
	return $('.attributes-group-area:visible').length > 0
}

export function isEnabledDefaults () {
	return !($(".def-val:disabled").length > 0 || $(".def-lock:disabled").length > 0);
}
